module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Training_red.22781c15.svg";